/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Layout } from "./components/Layout";
import { HomePage } from "./pages/Home";
import { AuthProvider } from "./lib/AuthContext";
import { CartProvider } from "./lib/CartContext";
import { WishlistProvider } from "./lib/WishlistContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { LoginPage, RegisterPage } from "./pages/Auth";
import { BecomeSellerPage } from "./pages/BecomeSeller";
import { SellerDashboardPage } from "./pages/Dashboard";
import { ShopDetailsPage } from "./pages/ShopDetails";
import { ProductDetailsPage } from "./pages/ProductDetails";
import { ShortUrlRedirect } from "./pages/ShortUrlRedirect";
import MeetingRoomPage from "./pages/MeetingRoom";
import { ProfilePage } from "./pages/Profile";
import { PricingPage } from "./pages/Pricing";
import { Market3DPage } from "./pages/Market3D";
import { 
  ShopsPage, 
  ProductsPage, 
  ServicesPage, 
} from "./pages/Placeholders";
import { CartPage } from "./pages/Cart";
import { WishlistPage } from "./pages/Wishlist";
import { OrdersPage } from "./pages/Orders";
import { BlogPage } from "./pages/Blog";
import { MallClubPage } from "./pages/MallClub";
import AnnouncementsPage from "./pages/Announcements";

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <CartProvider>
          <WishlistProvider>
            <Router>
              <Layout>
                <Routes>
                  <Route path="/" element={<Market3DPage />} />
                  <Route path="/classic" element={<HomePage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/shops" element={<ShopsPage />} />
                  <Route path="/products" element={<ProductsPage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/wishlist" element={<WishlistPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/orders" element={<OrdersPage />} />
                  <Route path="/pricing" element={<PricingPage />} />
                  <Route path="/blog" element={<BlogPage />} />
                  <Route path="/club" element={<MallClubPage />} />
                  <Route path="/announcements" element={<AnnouncementsPage />} />
                  <Route path="/become-seller" element={<BecomeSellerPage />} />
                  <Route path="/dashboard" element={<SellerDashboardPage />} />
                  <Route path="/shop/:id" element={<ShopDetailsPage />} />
                  <Route path="/product/:id" element={<ProductDetailsPage />} />
                  <Route path="/s/:shortId" element={<ShortUrlRedirect />} />
                  <Route path="/meeting/:meetingId" element={<MeetingRoomPage />} />
                </Routes>
              </Layout>
            </Router>
          </WishlistProvider>
        </CartProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}






